import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import routes from '../../../config/routes'
import { Logo } from '../../Header/styles'
import Icon from '../../Icon'
import Text from '../../Text'
import { Container, Divider, Link, MobileToggle } from './styles'

interface Props {

}

const AdminSidebar: React.FC<Props> = () => {
  const history = useHistory()
  const [open, setOpen] = useState(false)

  return (
    <>
      <MobileToggle
        label={(
          <Icon
            name={open ? 'x' : 'menu'}
          />
        )}
        backgroundColor="transparent"
        onClick={() => setOpen(prev => !prev)}
      />

      <Container
        open={open}
        onClick={() => {
          setOpen(false)
        }}
      >
        <Logo
          to={routes.index.path}
          style={{
            marginLeft: 30,
            marginBottom: 30,
          }}
        >
        </Logo>

        <Link
          to={routes.admin.index.path}
          isActive={() => history.location.pathname === routes.admin.index.path}
        >
          <Icon
            name="star"
          />
          Dashboard
        </Link>

        <Divider />

        <Text
          tag="span"
          color="black"
          style={{
            marginLeft: '30px',
            fontSize: 14,
            fontWeight: 'bold',
            marginBottom: 10,
          }}
        >
          OPERAÇÕES
        </Text>

        <Link
          to={routes.admin.user.index.path}
        >
          <Icon
            name="users"
          />
          Usuários
        </Link>
        <Link
          to={routes.admin.realty.index.path}
        >
          <Icon
            name="home"
          />
          Imóveis
        </Link>
        <Link
          to={routes.admin.chat.path}
        >
          <Icon
            name="message-square"
          />
          Chat
        </Link>
      </Container>
    </>
  )
}

export default AdminSidebar
